var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhDistWithdrawal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_456_2878",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_456_2878)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 3.51978H9.15186V4.64305H6.1996V4.91175C6.1996 9.81092 6.19848 14.7101 6.19624 19.6093C6.19624 19.8122 6.23353 19.8843 6.45728 19.8839C10.1646 19.876 13.872 19.876 17.5796 19.8839C17.7858 19.8839 17.831 19.8227 17.831 19.6236C17.8257 14.7177 17.8243 9.81149 17.8268 4.905V4.65192H14.8699V3.52568H19.0231V21H5V3.51978Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1809 2.67996C11.0745 2.19698 11.232 2.00127 11.6942 2C11.9242 2 12.1551 2 12.3842 2C12.7777 2.00337 12.9377 2.205 12.8581 2.59433C12.8561 2.62157 12.8561 2.64892 12.8581 2.67616C12.9939 2.67616 13.125 2.6732 13.2562 2.67616C13.6626 2.68712 13.9773 2.98324 13.9915 3.38944C14.0041 3.73996 14.0028 4.09175 13.9886 4.44396C13.9723 4.83582 13.6827 5.13868 13.2897 5.14501C12.4324 5.15851 11.5747 5.15851 10.7166 5.14501C10.5397 5.14049 10.3711 5.06813 10.2453 4.9427C10.1195 4.81727 10.0461 4.64823 10.0399 4.47011C10.0219 4.10609 10.0228 3.73996 10.037 3.37341C10.0517 2.99378 10.3483 2.70695 10.7254 2.68206C10.8696 2.67194 11.0154 2.67996 11.1809 2.67996ZM12.0118 3.32532H11.5928C10.9148 3.32532 10.87 3.37003 10.8805 4.0521C10.8846 4.3731 11.0062 4.4988 11.3229 4.50175C11.734 4.50512 12.1446 4.50175 12.5552 4.50175C13.0613 4.50175 13.1418 4.42329 13.1418 3.92261C13.1418 3.85933 13.1418 3.79606 13.1418 3.73321C13.1347 3.47211 13.0006 3.33165 12.7421 3.32574C12.4995 3.32068 12.2556 3.32617 12.0118 3.32617V3.32532Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.54 16.8516H9.87844V9.70823H9.23779C9.56755 9.13204 9.87551 8.59424 10.2015 8.021L11.1618 9.69389H10.5388L10.54 16.8516Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.61785 8.02783H8.2828V15.1708H8.92512L7.96143 16.8542C7.63963 16.2932 7.33293 15.7575 7.00317 15.1859H7.61952L7.61785 8.02783Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4205 7.89614C15.02 7.89614 15.6192 7.89614 16.2188 7.89614C16.4702 7.89614 16.6164 8.02269 16.6135 8.22643C16.6106 8.43016 16.4631 8.55923 16.2146 8.55965C15.0302 8.5619 13.8454 8.5619 12.6602 8.55965C12.3996 8.55965 12.2496 8.42552 12.2563 8.21292C12.263 8.00835 12.4046 7.89614 12.6644 7.8953C13.2499 7.89474 13.8352 7.89502 14.4205 7.89614Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4221 12.5905C13.8355 12.5905 13.2489 12.5905 12.6623 12.5905C12.3996 12.5905 12.2621 12.4787 12.2563 12.2703C12.2504 12.0619 12.4004 11.9274 12.6661 11.9269C13.8529 11.9244 15.0401 11.9244 16.2275 11.9269C16.4639 11.9269 16.6097 12.0573 16.6139 12.2517C16.6185 12.4563 16.471 12.5892 16.2238 12.5892C15.6229 12.5921 15.0225 12.5905 14.4221 12.5905Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4453 15.9605C15.0319 15.9605 15.6174 15.9605 16.2017 15.9605C16.4615 15.9605 16.6174 16.0921 16.614 16.3004C16.6107 16.5017 16.4598 16.6252 16.2097 16.6252C15.0247 16.6252 13.84 16.6252 12.6553 16.6252C12.3771 16.6252 12.2225 16.4675 12.2606 16.2342C12.2899 16.0558 12.4182 15.9613 12.6473 15.9605C13.2465 15.9588 13.8461 15.9605 14.4453 15.9605Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhDistWithdrawal);
export default __webpack_public_path__ + "static/media/wh_dist_withdrawal.3419752025d30328216bdacc14d7c9ce.svg";
export { ForwardRef as ReactComponent };